module.exports = __webpack_public_path__ + "img/mhd_ht_logo.c204e703.png";